import { supabase } from '../lib/supabase';

// ---- Project Contractor/Vendor Associations ----

export const getProjectContractors = async (projectId) => {
  const [scRes, vRes] = await Promise.all([
    supabase?.from('project_sub_contractors')?.select('sub_contractor_id, sub_contractors(id, name, contact_name, contact_email, contact_phone)')?.eq('project_id', projectId),
    supabase?.from('project_vendors')?.select('vendor_id, vendors(id, name, contact_name, contact_email, contact_phone)')?.eq('project_id', projectId),
  ]);

  return {
    subContractors: (scRes?.data || [])?.map(r => r?.sub_contractors)?.filter(Boolean),
    vendors: (vRes?.data || [])?.map(r => r?.vendors)?.filter(Boolean),
  };
};

export const setProjectContractors = async (projectId, { subContractorIds = [], vendorIds = [] }) => {
  // Delete existing and re-insert for simplicity
  await Promise.all([
    supabase?.from('project_sub_contractors')?.delete()?.eq('project_id', projectId),
    supabase?.from('project_vendors')?.delete()?.eq('project_id', projectId),
  ]);

  const inserts = [];

  if (subContractorIds?.length > 0) {
    inserts?.push(
      supabase?.from('project_sub_contractors')?.insert(
        subContractorIds?.map(id => ({ project_id: projectId, sub_contractor_id: id }))
      )
    );
  }
  if (vendorIds?.length > 0) {
    inserts?.push(
      supabase?.from('project_vendors')?.insert(
        vendorIds?.map(id => ({ project_id: projectId, vendor_id: id }))
      )
    );
  }

  if (inserts?.length > 0) {
    await Promise.all(inserts);
  }
};

// ---- Bid Contractor/Vendor Associations ----

export const getBidContractors = async (bidId) => {
  const [scRes, vRes] = await Promise.all([
    supabase?.from('bid_sub_contractors')?.select('sub_contractor_id, sub_contractors(id, name, contact_name, contact_email, contact_phone)')?.eq('bid_id', bidId),
    supabase?.from('bid_vendors')?.select('vendor_id, vendors(id, name, contact_name, contact_email, contact_phone)')?.eq('bid_id', bidId),
  ]);

  return {
    subContractors: (scRes?.data || [])?.map(r => r?.sub_contractors)?.filter(Boolean),
    vendors: (vRes?.data || [])?.map(r => r?.vendors)?.filter(Boolean),
  };
};

export const setBidContractors = async (bidId, { subContractorIds = [], vendorIds = [] }) => {
  await Promise.all([
    supabase?.from('bid_sub_contractors')?.delete()?.eq('bid_id', bidId),
    supabase?.from('bid_vendors')?.delete()?.eq('bid_id', bidId),
  ]);

  const inserts = [];

  if (subContractorIds?.length > 0) {
    inserts?.push(
      supabase?.from('bid_sub_contractors')?.insert(
        subContractorIds?.map(id => ({ bid_id: bidId, sub_contractor_id: id }))
      )
    );
  }
  if (vendorIds?.length > 0) {
    inserts?.push(
      supabase?.from('bid_vendors')?.insert(
        vendorIds?.map(id => ({ bid_id: bidId, vendor_id: id }))
      )
    );
  }

  if (inserts?.length > 0) {
    await Promise.all(inserts);
  }
};
